// extracted by mini-css-extract-plugin
module.exports = {"pageName":"SalesReport_pageName__3cw6m","date":"SalesReport_date__2bJM5"};